import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import logo from '../images/barista_logo.png';
import coffe_girl from '../images/coffee-girl.png';
import table from '../images/table.svg';

export default function PageHeader() {
  const [searchParams] = useSearchParams();
  const [tableNumber, setTableNumber] = useState(localStorage.getItem('tableNumber') || '--'); // Default to '--' or handle gracefully

  useEffect(() => {
    const tableFromUrl = searchParams.get('table');
    if (tableFromUrl) {
      setTableNumber(tableFromUrl);
      localStorage.setItem('tableNumber', tableFromUrl);
    }
  }, [searchParams]);

  return (
    <>
      <div className="container-fluid top_header_div p-0 mb-4">
        <div className="container">
          <div className="row">

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 mt-4">
              {/* logo */}
              <a href='/'>
                <img src={logo} alt='' className='d-block top_logo' style={{ width: '200px' }}></img>
              </a>
              {/* logo  */}
            </div>

            <div className="clearfix"></div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-5">
              <img src={coffe_girl} alt='' className='d-block w-100'></img>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-7">
              <h2 className='main_heading mb-3' style={{ color: '#ffffff' }}>WELCOME TO<br /> BARISTA <b>PAPILIYANA</b></h2>

              <div className="clearfix"></div>

              {/* table no box */}
              <div className="bg_white rounded p-2 mb-0 shadow" style={{ width: 'fit-content' }}>
                <div className="col px-3 d-flex align-items-center">
                  <div className="text-center me-2">
                    <img src={table} alt="" style={{ width: '40px' }}></img>
                    <p className="ex_small_text mb-0">Outdoor</p>
                  </div>

                  <div className="div">
                    <p className="orange_text mb-0">Table No</p>
                    <h1 className="heading fw-bold mb-0">{tableNumber}</h1>
                  </div>
                </div>
              </div>
              {/* table no box */}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
